"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _Popover = _interopRequireDefault(require("../Popover"));

var _styling = require("../../toolkit/styling");

var _dimen = require("../../toolkit/dimen");

var _localization = require("../../toolkit/localization");

var _providers = require("../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* babel-plugin-inline-import '../../img/arrow-to-up.svg' */

/* SVGs */
var upArrow = "data:image/svg+xml;base64,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";

/* babel-plugin-inline-import '../../img/arrow-to-up-white.svg' */
var upArrowWhite = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjJweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjIgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjUgKDY3NDY5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5BcnJvd190b19yaWdodF8yNHgyNDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPgogICAgICAgIDxwYXRoIGQ9Ik03NywxODIgTDc3LDE2NiBDNzcsMTY1LjQ0NzcxNSA3Ny40NDc3MTUzLDE2NSA3OCwxNjUgQzc4LjU1MjI4NDcsMTY1IDc5LDE2NS40NDc3MTUgNzksMTY2IEw3OSwxODIgQzc5LDE4Mi41NTIyODUgNzguNTUyMjg0NywxODMgNzgsMTgzIEM3Ny40NDc3MTUzLDE4MyA3NywxODIuNTUyMjg1IDc3LDE4MiBaIE03OC43MTM2MjcxLDE2My4yOTUzNjcgTDg4LjcwNDQwNiwxNzMuMjc4NDc1IEM4OS4wOTg1MzEzLDE3My42NzIyOTcgODkuMDk4NTMxMywxNzQuMzEwODEgODguNzA0NDA2LDE3NC43MDQ2MzMgQzg4LjMxMDI4MDYsMTc1LjA5ODQ1NiA4Ny42NzEyNzcyLDE3NS4wOTg0NTYgODcuMjc3MTUxOSwxNzQuNzA0NjMzIEw3OCwxNjUuNDM0NjA0IEw2OC43MjI4NDgxLDE3NC43MDQ2MzMgQzY4LjMyODcyMjgsMTc1LjA5ODQ1NiA2Ny42ODk3MTk0LDE3NS4wOTg0NTYgNjcuMjk1NTk0LDE3NC43MDQ2MzMgQzY2LjkwMTQ2ODcsMTc0LjMxMDgxIDY2LjkwMTQ2ODcsMTczLjY3MjI5NyA2Ny4yOTU1OTQsMTczLjI3ODQ3NSBMNzcuMjg2MzcyOSwxNjMuMjk1MzY3IEM3Ny42ODA0OTgzLDE2Mi45MDE1NDQgNzguMzE5NTAxNywxNjIuOTAxNTQ0IDc4LjcxMzYyNzEsMTYzLjI5NTM2NyBaIiBpZD0icGF0aC0xIj48L3BhdGg+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0iVjUiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJCYWNrLXRvLXRvcC9ib3R0b20tYnV0dG9ucyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY3LjAwMDAwMCwgLTE2My4wMDAwMDApIj4KICAgICAgICAgICAgPG1hc2sgaWQ9Im1hc2stMiIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGF0aC0xIj48L3VzZT4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGlkPSJBcnJvd190b19yaWdodF8yNHgyNCIgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjcGF0aC0xIj48L3VzZT4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";

var TopBottomButton = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TopBottomButton, _Component);

  var _super = _createSuper(TopBottomButton);

  function TopBottomButton() {
    var _this;

    (0, _classCallCheck2["default"])(this, TopBottomButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;

    _this.handleBackToTop = function () {
      if (!_this.isTop) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
      }
    };

    _this.handleGoToBottom = function () {
      if (!_this.isBottom) {
        var body = document.body;

        if (body) {
          window.scrollTo({
            top: body.scrollHeight,
            left: 0,
            behavior: "smooth"
          });
        }
      }
    };

    return _this;
  }

  (0, _createClass2["default"])(TopBottomButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          includedButtons = _this$props.includedButtons,
          style = _this$props.style;
      var styles = this.styles;

      var _LocalizationStore = new _localization.LocalizationStore(this.context),
          i18n = _LocalizationStore.i18n;

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        className: (0, _styling.css)(styles.root, className)
      }, (includedButtons == "both" || includedButtons == "top") && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(styles.container, this.isTop && styles.inactive),
        onClick: this.handleBackToTop
      }, /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
        popoverContent: i18n("Back to Top"),
        popoverFontSize: 12,
        position: "top center",
        popoverWhitespace: "nowrap"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(styles.btn, styles.up)
      }))), (includedButtons == "both" || includedButtons == "bottom") && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(styles.container, this.isBottom && styles.inactive),
        onClick: this.handleGoToBottom
      }, /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
        popoverContent: i18n("Back to Bottom"),
        popoverFontSize: 12,
        position: "bottom center",
        popoverWhitespace: "nowrap"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(styles.btn, styles.down)
      }))));
    }
  }, {
    key: "styles",
    get: function get() {
      // Page is not fully loaded yet, hide buttons first.
      // And show them after user scrolled
      var hide = !_dimen.DimenStore.instance().pageScrolled;
      var _this$context$theming = this.context.theming,
          _this$context$theming2 = _this$context$theming.theme,
          textDark = _this$context$theming2.textDark,
          surfaceLightest = _this$context$theming2.surfaceLightest,
          fonts = _this$context$theming.fonts;
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: fonts.semibold,
          transition: "opacity 250ms",
          visibility: hide ? "hidden" : "visible",
          opacity: hide ? 0 : 1
        },
        container: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: textDark,
          fontSize: "14px",
          marginTop: "16px",
          cursor: "pointer",
          transition: "opacity 250ms"
        },
        inactive: {
          opacity: 0.4
        },
        btn: {
          borderRadius: 4,
          backgroundColor: surfaceLightest,
          backgroundImage: "url(".concat(upArrow, ")"),
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          border: "1px solid ".concat(textDark),
          boxShadow: "0 4px 6px 0 rgba(175, 199, 209, 0.4)",
          width: "40px",
          height: "40px",
          transition: "background-color 250ms"
        },
        up: {
          ":hover": {
            backgroundColor: !this.isTop ? textDark : undefined,
            backgroundImage: !this.isTop ? "url(".concat(upArrowWhite, ")") : undefined
          }
        },
        down: {
          transform: "rotate(180deg)",
          ":hover": {
            backgroundColor: !this.isBottom ? textDark : undefined,
            backgroundImage: !this.isBottom ? "url(".concat(upArrowWhite, ")") : undefined
          }
        }
      });
    }
  }, {
    key: "isTop",
    get: function get() {
      return _dimen.DimenStore.instance().pageYOffset <= 10;
    }
  }, {
    key: "isBottom",
    get: function get() {
      var body = document.body;

      if (!body) {
        return false;
      }

      var dimenStore = _dimen.DimenStore.instance();

      var maxY = body.scrollHeight - dimenStore.screenInnerHeight - 10;
      return dimenStore.pageYOffset >= maxY;
    }
  }]);
  return TopBottomButton;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  includedButtons: {
    required: true,
    type: "\"top\" | \"bottom\" | \"both\"",
    description: "Controls which buttons appear: 'top', 'bottom' or 'both'"
  }
}, _class3.demoProps = {
  includedButtons: "both"
}, _class3.defaultProps = {
  includedButtons: "both"
}, _class3.discussion = "\n  The buttons are initially invisible after page is loaded,\n  just make the browser smaller and scroll.\n  ", _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "isTop", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isTop"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "isBottom", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isBottom"), _class2.prototype)), _class2)) || _class;

var _default = TopBottomButton;
exports["default"] = _default;